<template>
  <div>
      <div class="class_box">
          <div class="title">上周学生扣分表</div>
          <el-table border :data="tableData" :size="isMB?'mini':'medium'" stripe class="report_table">
            <el-table-column prop="FullName" label="姓名" align="center">
                <template slot-scope="{row}">
                    <span v-if="(row.HandleStatus==0&&row.DisciplinePoint>=8)||row.AfterPoint>=6" style="color:#f11;">{{row.FullName}}</span>
                    <span v-else>{{row.FullName}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="LastWeekPoint" label="上周扣分值" align="center" />
            <el-table-column prop="DisciplinePoint" label="当前周期总扣分值" align="center" />
            <el-table-column prop="Dormitory" label="宿舍号" align="center" />
          </el-table>
      </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      api: require("@/api/attendance/disrecord").default,
      tableData: [],
      day: "",
      isMB: this.$store.state.isMB,
    };
  },
  beforeMount() {
      var today = new Date();
      var day = today.getDay();
      var StartDate = this.$commonJs.toDateString(today.getTime() - (day+6) * 86400000);
      this.api.getClassReport({ StartDate }).then(res => {
          if(res.Code==0) {
            this.tableData = res.Data;
          } else {
              this.$message.error(res.Msg)
          }
      })
  },
};
</script>
<style lang="scss" scoped>
.class_box {
    padding: 1.5% 4% 1.5%;
    .title {
        line-height: 40px;
        font-size: 16px;
    }
    .report_table {
        // /deep/ .el-table__body-wrapper {
        //     max-height: 80vh;
        //     overflow-y: auto;
        // }
        /deep/ .el-table__body-wrapper::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }

        /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            -webkit-box-shadow: inset 0 0 5px rgba(150, 150, 150, 0.2);
            background: rgba(0, 0, 0, 0.2);
        }

        /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            -webkit-box-shadow: inset 0 0 5px rgba(150, 150, 150, 0.2);
            border-radius: 0;
            background: rgba(0, 0, 0, 0.1);
        }
    }
}
</style>